/** Event titles from the course lane list. Classified events stay unnamed. */
export const EVENT_TITLES: Record<string, string> = {
  '0321-COMM-1207': 'Transmit Tactical Reports',
  '0321-COMM-2201': 'Operate Tactical Satellite (TACSAT) Systems',
  '0321-INTL-2501': 'Submit Information Requirements (IR)',
  '0321-PAT-4101': 'Conduct Team Planning',
  '0321-RECN-4001': 'Conduct Zone Reconnaissance',
  '0321-RECN-4002': 'Establish a Reconnaissance/Surveillance (R&S) Post',
  'RECN-C2-1001': 'Conduct individual preparations for combat',
  'RECN-C2-1002': 'Develop a route plan',
  'RECN-C2-1003': 'Prepare a route overlay',
  'RECN-C2-1004': 'Prepare a Terrain Model',
  'RECN-C2-2002': 'Prepare a digital route overlay',
  'RECN-C2-2406': 'Issue a warning order',
  'RECN-C2-2407': 'Lead unit preparations for combat',
  'RECN-C2-2408': 'Evaluate a route plan',
  'RECN-C2-2409': 'Evaluate a route overlay',
  'RECN-C2-2410': 'Develop a communications plan',
  'RECN-C2-2411': 'Develop a sustainment plan',
  'RECN-C2-2412': 'Evaluate a terrain model/visual aid',
  'RECN-C2-2413': 'Develop a patrol order',
  'RECN-C2-2414': 'Issue a patrol order',
  'RECN-C2-2502': 'Establish a Reconnaissance Operations Center (ROC)',
  'RECN-C2-2503': 'Perform duties as Watch Officer in the Reconnaissance Operations Center (ROC)',
  'RECN-C2-2504': 'Maintain a situation map',
  'RECN-C2-2505': 'Maintain a Reconnaissance operational journal',
  'RECN-C2-2511': 'Establish communications',
  'RECN-C2-2512': 'Conduct detailed ground reconnaissance planning',
  'RECN-C2-2513': 'Produce an operation order',
  'RECN-C2-2514': 'Issue an operations order',
  'RECN-C2-2515': 'Conduct a Ground Reconnaissance confirmation brief',
  'RECN-C2-4001': 'Prepare for Operations',
  'RECN-C2-4002': 'Conduct Post Mission Consolidation',
  'RECN-C2-5001': 'Deploy to the Operational Area',
  'RECN-C2-5002': 'Conduct Command and Control (C2) of Reconnaissance Platoon Operations',
  'RECN-COLL-1024': 'Transmit a ground reconnaissance report',
  'RECN-COMM-1003': 'Operate an HF radio set',
  'RECN-COMM-1006': 'Operate a field computer',
  'RECN-COMM-1009': 'Employ a field expedient antenna',
  'RECN-COMM-1013': 'Maintain a communication log',
  'RECN-COMM-2407': 'Supervise team communications',
  'RECN-DEMO-1001': 'Employ pyrotechnics',
  'RECN-DEMO-1005': 'Construct a non-electric initiation set',
  'RECN-DEMO-1007': 'Clear a non-electric initiation set misfire',
  'RECN-DEMO-1008': 'Construct a single detonation cord firing-system',
  'RECN-DEMO-2401': 'Direct the employment of demolitions',
  'RECN-DEMO-3001': 'Employ demolitions',
  'RECN-FSPT-2401': 'Develop a fire support plan',
  'RECN-FSPT-2402': 'Develop a target list',
  'RECN-FSPT-2403': 'Develop a schedule of fires',
  'RECN-FSPT-2501': 'Develop a fire support coordination overlay',
  'RECN-GRND-1001': 'Execute duties within a reconnaissance patrol',
  'RECN-GRND-1002': 'Perform individual movement techniques',
  'RECN-GRND-1003': 'Perform individual actions in a recon patrol',
  'RECN-GRND-1004': 'Perform immediate actions as a member of a recon patrol upon contact with the enemy',
  'RECN-GRND-1008': 'Navigate with a compass',
  'RECN-GRND-1009': 'Navigate with a map and compass',
  'RECN-GRND-1010': 'Navigate utilizing a Global Positioning System (GPS)',
  'RECN-GRND-1013': 'Establish an Observation Post (OP)',
  'RECN-GRND-1016': 'Employ anti-tracking techniques',
  'RECN-GRND-1017': 'Counter a unit employing anti-tracking techniques',
  'RECN-GRND-1020': 'Perform individual actions in establishing a Helicopter Landing Site',
  'RECN-GRND-1022': 'Maintain a patrol log',
  'RECN-GRND-1023': 'Perform individual actions during the establishment of a drop zone',
  'RECN-GRND-2006': 'Cache equipment',
  'RECN-GRND-2402': 'Lead a patrol',
  'RECN-GRND-2403': 'Lead immediate actions upon contact with the enemy',
  'RECN-GRND-2407': 'Supervise the operation of an Observation Post (OP)',
  'RECN-GRND-2411': 'Lead a recon unit in the establishment of a Helicopter Landing Zone',
  'RECN-GRND-2412': 'Supervise the marking of a Drop Zone',
  'RECN-GRND-2413': 'Lead a team in offensive operations',
  'RECN-GRND-2421': 'Prepare a fire plan sketch',
  'RECN-GRND-2512': 'Lead a platoon in offensive operations',
  'RECN-GRND-3001': 'Establish an Observation Post (OP)',
  'RECN-GRND-3002': 'React to Contact',
  'RECN-GRND-4001': 'Conduct Ground Reconnaissance',
  'RECN-GRND-4002': 'Conduct a Patrol',
  'RECN-GRND-4003': 'React to Contact',
  'RECN-GRND-4005': 'Establish a Landing Zone',
  'RECN-GRND-4007': 'Conduct Sensor Support',
  'RECN-GRND-4027': 'Establish a Drop Zone',
  'RECN-GRND-5001': 'Conduct Ground Reconnaissance',
  'RECN-GRND-5002': 'Conduct Actions on Contact',
  'RECN-GRND-5004': 'Establish a Patrol Base',
  'RECN-GRND-5005': 'Conduct a Link Up',
  'RECN-GRND-5006': 'Establish a Landing Zone (LZ)',
  'RECN-GRND-5007': 'Establish a Drop Zone',
  'RECN-GRND-5008': 'Conduct Sensor Support',
  'RECN-INTL-2001': 'Conduct Pattern Analysis',
  'RECN-INTL-2501': 'Integrate Ground Reconnaissance into the Marine Corps Intelligence, Surveillance, Reconnaissance Enterprise (MCISR-E) concept of operations',
  'RECN-INTL-2510': 'Produce a Reconnaissance After-action, Information, Dissemination, Exploitation Report (RAIDERREP)',
  'RECN-INTL-4001': 'Provide Level I Intelligence Reports',
  'RECN-INTL-4002': 'Provide Level IB Intelligence Reports',
  'RECN-INTL-5001': 'Provide Level I Intelligence Reports',
  'RECN-LOG-3001': 'Conduct Aid and Litter Team Duties',
  'RECN-LOG-4001': 'Coordinate Tactical Logistics',
  'RECN-LOG-4002': 'Conduct casualty care',
  'RECN-LOG-5001': 'Coordinate Tactical Logistics',
  'RECN-PHOT-1001': 'Capture a daylight image',
  'RECN-PHOT-1002': 'Capture an unaided night image',
  'RECN-PHOT-1003': 'Capture an aided night image',
  'RECN-PHOT-1004': 'Edit Photographic Images',
  'RECN-PHOT-3001': 'Prepare Ground Perspective Imagery Systems for Operations',
  'RECN-PHOT-3002': 'Employ Ground Perspective Imagery Systems',
  'RECN-PHOT-3003': 'Maintain Ground Perspective Imagery Systems',
  'RECN-RAID-2004': 'Perform individual actions in a specialized limited scale raid',
  'RECN-RAID-2401': 'Lead a unit in a raid',
  'RECN-RAID-4001': 'Conduct Assault Element actions during a raid',
  'RECN-RAID-4002': 'Conduct Support Element actions during a raid',
  'RECN-RAID-4003': 'Conduct Security Element actions during a raid',
  'RECN-RAID-4004': 'Conduct Site Exploitation',
  'RECN-RAID-5001': 'Conduct a Specialized Raid',
  'RECN-RAID-5002': 'Conduct Assault Element actions during a raid',
  'RECN-RAID-5003': 'Conduct Support Element actions during a raid',
  'RECN-RAID-5004': 'Conduct Security Element actions during a raid',
  'RECN-RAID-5005': 'Conduct Sensitive Site Exploitation (SSE)',
  'RECN-RAID-5007': 'Conduct a Tactical Call Out (TCO)',
  'RECN-SERE-2003': 'Avoid recognition and detection',
  'RECN-SERE-2004': 'Counter an attack/sentry dog attack',
  'RECN-SERE-2005': 'Navigate to a known location',
  'RECN-SERE-2006': 'Use recovery devices',
  'RECN-SERE-2008': 'Obtain potable water',
  'RECN-SERE-2009': 'Utilize a survival diet',
  'RECN-SERE-2012': 'Maintain personal survival items',
  'RECN-SERE-2013': 'Manage survival medicine utilizing field expedient measures',
  'RECN-SERE-2501': 'Develop an Evasion Plan of Action (EPA)',
  'RECN-SERE-3001': 'Execute an Evasion Plan of Action (EPA)',
  'RECN-SERE-4001': 'Execute an Evasion Plan of Action (EPA)',
  'RECN-SHAP-1001': 'Call for indirect fire using the grid method',
  'RECN-SHAP-1002': 'Call for indirect fire using the polar method',
  'RECN-SHAP-1005': 'Call for indirect fire using the shift from a known point method',
  'RECN-SHAP-2004': 'Conduct Close Air Support (CAS) as a non-TAC qualified individual',
  'RECN-SHAP-2006': 'Operate target location equipment',
  'RECN-SHAP-2007': 'Mark targets for fires',
  'RECN-SHAP-2501': 'Direct Shaping Operations',
  'RECN-SHAP-3001': 'Conduct Sniper Team operations',
  'RECN-SHAP-4001': 'Conduct Shaping Operations',
  'RECN-SHAP-4002': 'Conduct Sniper operations',
  'RECN-SHAP-4007': 'Conduct an Ambush',
  'RECN-SHAP-5002': 'Conduct Sniper Operations',
  'RECN-SHAP-5007': 'Conduct an Ambush',
  'RECN-SNPR-2001': 'Engage targets utilizing advanced marksmanship techniques',
  'RECN-SPIE-2002': 'Conduct a parachute insertion into a Special Purpose Drop Zone',
  'RECN-SURV-1001': 'Execute surveillance',
  'RECN-SURV-1002': 'Prepare a range card',
  'RECN-SURV-1003': 'Prepare a panoramic/military sketch',
  'RECN-SURV-1005': 'Operate observation devices',
  'RECN-SURV-1007': 'Employ technical surveillance equipment',
  'RECN-SURV-2003': 'Employ surveillance security measures',
  'RECN-SURV-2004': 'Conduct surveillance detection',
  'RECN-SURV-2401': 'Lead a recon unit during a surveillance mission',
  'RECN-SURV-2403': 'Conduct a battlefield turn-over',
  'RECN-SURV-4001': 'Conduct Surveillance',
  'RECN-SURV-5001': 'Conduct Surveillance Operations',
};

export const CLASSIFIED_EVENTS = new Set(['RECN-SERE-2001', 'RECN-SERE-2007']);
